<script lang="ts">
	import { onMount } from 'svelte';
	import {
		// ask_php_to_exchange_token,
		// enable_alexa_skill,
		comes_back_from_amazon,
		get_active_integrations,
	} from '../services/http';
	import { querystring } from 'svelte-spa-router';

	import { user_data } from 'src/stores/account/user';
	import { active_integrations, skill_stage } from 'src/stores/integrations/alexa';
	import { currentUnitId } from 'src/stores/account/home';

	import { resolveAlexaSkillStage } from '../components/Integrations/AlexaAppLinking/constants_and_helpers';

	import LinkingProcessStartShelly from '../components/Integrations/AlexaAppLinking/LinkingProcessStartShelly.svelte';

	import { Container, Loader } from '@Shelly/shelly-design-system';
	import { parseQuerystring } from 'src/helpers/utilities';

	let exchange_token_count = 0;

	// export let params = {};
	let msg = '';
	let sub_msg = '';
	let success;
	let loading = false;

	const host = import.meta.env.VITE_APP_BUCKET || window.location.host;

	onMount(async () => {
		let { code, error, error_description } = parseQuerystring($querystring);

		if (code && !$active_integrations.includes('alexa') && exchange_token_count < 1) {
			const stage = resolveAlexaSkillStage($skill_stage);
			if ($skill_stage !== stage) {
				skill_stage.set(stage);
			}

			loading = true;
			exchange_token_count++;

			const res = await comes_back_from_amazon(
				host.split('.')[0],
				code,
				stage,
				$user_data,
				$currentUnitId,
			);

			if (res.isok) {
				success = true;
				msg = '';
				sub_msg = '';
				active_integrations.add('alexa');
				await get_active_integrations();
				loading = false;
			} else {
				success = false;
				msg = 'Linking process failed!';
				sub_msg =
					'We are experiencing a problem connecting with Alexa to link your account. Please, try again!';
				loading = false;
			}
		} else if (error || error_description) {
			success = false;

			if (error === 'access_denied') {
				msg = 'Access to Amazon account was denied';
				sub_msg = 'We can not continue linking process to Shelly skill. Please, try again!';
			} else {
				msg = 'Linking process failed!';
				sub_msg =
					'We are experiencing a problem connecting with Alexa to link your account. Please, try again!';
			}
		}
	});
</script>

<Container class="mb-s" padding={'0'}>
	{#if loading}
		<Loader size="m" />
	{:else}
		<LinkingProcessStartShelly error={!success ? msg : false} err_msg={!success ? sub_msg : false} />
	{/if}
</Container>
